export const VISIT_TYPE_PRESENTIAL = 'presential';
export const VISIT_LOCATION_OFFICE = 'office';
export const VISIT_LOCATION_PROJECT = 'project';

export const visitTypeOptions = [
  { value: 'virtual', label: 'Virtual' },
  { value: VISIT_TYPE_PRESENTIAL, label: 'Presencial' },
];

export const visitLocationOptions = [
  { value: 'office', label: 'Oficina Propi' },
  { value: 'project', label: 'En el proyecto' },
];
